import { render, staticRenderFns } from "./PelleTab.vue?vue&type=template&id=bb6447ec&scoped=true&"
import script from "./PelleTab.vue?vue&type=script&lang=js&"
export * from "./PelleTab.vue?vue&type=script&lang=js&"
import style0 from "./PelleTab.vue?vue&type=style&index=0&id=bb6447ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6447ec",
  null
  
)

export default component.exports